import { GET_SUPER_REGION, SET_SUPER_REGION } from "./SuperRegionType";

const getSuperRegion = (divisionCode?: any) => ({
    type: GET_SUPER_REGION,
    divisionCode
});

const setSuperRegion = (superRegionDropDownList: any) => ({
    type: SET_SUPER_REGION,
    superRegionDropDownList: superRegionDropDownList
});

export {
    getSuperRegion,
    setSuperRegion
}
